<ui-grid
  [dsConfig]="activityLogConfig()"
  [showPanelHeader]="true"
  [panelHeaderConfig]="panelHeaderConfig()"
  [reloadOnChangeTrigger]="reloadGridTrig()"
  [noDataFoundMessage]="resolvedNoDataFoundMessage()"
  (panelHeaderButtonClick)="onPanelHeaderButtonClick($event)"
  [showReloadButton]="true"
/>
